// queries/useEmailSignUp.ts
"use client";
import { UserEmailLogin } from "types";
import { fetch } from "libs";
import { POST_SIGN_UP } from "api";

const emailSignUp = (args: UserEmailLogin) => {
  return fetch(POST_SIGN_UP, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({
      otp_encrypted: args.otp_encrypted,
      nsfw_consent: args.nsfw_consent,
      newsletter_consent: args.newsletter_consent,
      adult_consent: args.adult_consent,
    }),
  });
};

export default emailSignUp;
